import { utils } from '@costar/theme-ui';

function getAutocompleteUtilityClass(slot) {
  return utils.generateUtilityClass('TuiAutocomplete', slot);
}
var autocompleteClasses = utils.generateUtilityClasses('TuiAutocomplete', ['root', 'fullWidth', 'focused', 'focusVisible', 'tag', 'tagSizeSmall', 'tagSizeMedium', 'hasPopupIcon', 'hasClearIcon', 'inputRoot', 'input', 'inputFocused', 'endAdornment', 'clearIndicator', 'popupIndicator', 'popupIndicatorOpen', 'popper', 'popperDisablePortal', 'paper', 'listbox', 'loading', 'noOptions', 'option', 'groupLabel', 'groupUl']);

export default autocompleteClasses;
export { getAutocompleteUtilityClass };
//# sourceMappingURL=autocomplete-classes.esm.js.map
